import { render } from "./SuppliersSection.vue?vue&type=template&id=a97cc31c"
import script from "./SuppliersSection.vue?vue&type=script&lang=js"
export * from "./SuppliersSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__